// ─── App Dropdown Registry ──────────────────────────────────────
// Every dropdown in the app that can be powered by a DDL collection.
// Each entry has a unique `id` and a human-readable `label`.

const APP_DROPDOWNS = [
  { id: 'object_type',           label: 'Object — Type' },

  // Design page dropdowns (page 2 of the object edit modal)
  { id: 'design_objectSpec',     label: 'Design — Object Specification' },
  { id: 'design_attributeA',     label: 'Design — Attribute A' },
  { id: 'design_attributeAType', label: 'Design — Attribute A Type' },
  { id: 'design_attributeB',     label: 'Design — Attribute B' },
  { id: 'design_attributeBType', label: 'Design — Attribute B Type' },

  // Sizing page dropdowns (page 3)
  { id: 'sizing_dimensionA',             label: 'Sizing — Dimension A' },
  { id: 'sizing_dimensionB',             label: 'Sizing — Dimension B' },
  { id: 'sizing_objectCloselyResembles', label: 'Sizing — Object Closely Resembles' },

  // Construction page dropdowns (page 4)
  { id: 'construction_buildingStandard', label: 'Construction — Building Standard' },
  { id: 'construction_material1',        label: 'Construction — Material 1' },
  { id: 'construction_material1Type',    label: 'Construction — Material 1 Type' },
  { id: 'construction_material2',        label: 'Construction — Material 2' },
  { id: 'construction_material2Type',    label: 'Construction — Material 2 Type' },
  { id: 'construction_insulation',       label: 'Construction — Insulation' },

  // Miscellaneous page dropdowns (page 5)
  { id: 'misc_heatingElement',           label: 'Miscellaneous — Heating Element' },
  { id: 'misc_structuralSupport',        label: 'Miscellaneous — Structural Support' },
  { id: 'misc_yearOfConstruction',       label: 'Miscellaneous — Year of Construction' },
  { id: 'misc_previousTIYear',           label: 'Miscellaneous — Previous TI Inspection Year' },

  // Assessment settings
  { id: 'ddl_reportingPeriod', label: 'Assessment — Reporting Period' },

  // General Inspection Information (object-level, filled before first inspection)
  { id: 'general_inspectionStandard', label: 'General — Inspection Standard' },
  { id: 'general_accountManager',     label: 'General — Account Manager' },
  { id: 'general_leadNDTOperator',    label: 'General — Lead NDT Operator' },
  { id: 'general_l3Inspector',        label: 'General — L3 Inspector' },

  // VT-OSI — Visual Testing Out-of-Service Inspection
  { id: 'vtosi_inspectionStatus', label: 'VT-OSI — Inspection Status' },
  { id: 'vtosi_terraProcedure',   label: 'VT-OSI — Terra Procedure' },
  { id: 'vtosi_typeOfInspection', label: 'VT-OSI — Type of Inspection' },
  { id: 'vtosi_surfaceCondition', label: 'VT-OSI — Surface Condition' },
  { id: 'vtosi_insideOutside',    label: 'VT-OSI — Inside / Outside' },
  { id: 'vtosi_manualOrDrone',    label: 'VT-OSI — Manual or Drone' },
  { id: 'vtosi_ndtReporter',      label: 'VT-OSI — NDT Reporter' },

  // VT-ISI — Visual Testing In-Service Inspection
  { id: 'vtisi_inspectionStatus', label: 'VT-ISI — Inspection Status' },
  { id: 'vtisi_terraProcedure',   label: 'VT-ISI — Terra Procedure' },
  { id: 'vtisi_typeOfInspection', label: 'VT-ISI — Type of Inspection' },
  { id: 'vtisi_surfaceCondition', label: 'VT-ISI — Surface Condition' },
  { id: 'vtisi_insideOutside',    label: 'VT-ISI — Inside / Outside' },
  { id: 'vtisi_manualOrDrone',    label: 'VT-ISI — Manual or Drone' },
  { id: 'vtisi_ndtReporter',      label: 'VT-ISI — NDT Reporter' },

  // VT — Visual Inspection (umbrella; uses the 'vt' typePrefix in
  // INSPECTION_TYPE_CONFIG, mirrors VT-OSI/VT-ISI field set).
  { id: 'vt_inspectionStatus', label: 'VT — Inspection Status' },
  { id: 'vt_terraProcedure',   label: 'VT — Terra Procedure' },
  { id: 'vt_typeOfInspection', label: 'VT — Type of Inspection' },
  { id: 'vt_surfaceCondition', label: 'VT — Surface Condition' },
  { id: 'vt_insideOutside',    label: 'VT — Inside / Outside' },
  { id: 'vt_manualOrDrone',    label: 'VT — Manual or Drone' },
  { id: 'vt_ndtReporter',      label: 'VT — NDT Reporter' },

  // UT-OSI — Ultrasonic Testing Out-of-Service Inspection
  { id: 'utosi_inspectionStatus', label: 'UT-OSI — Inspection Status' },
  { id: 'utosi_terraProcedure',   label: 'UT-OSI — Terra Procedure' },
  { id: 'utosi_typeOfInspection', label: 'UT-OSI — Type of Inspection' },
  { id: 'utosi_surfaceCondition', label: 'UT-OSI — Surface Condition' },
  { id: 'utosi_insideOutside',    label: 'UT-OSI — Inside / Outside' },
  { id: 'utosi_manualOrDrone',    label: 'UT-OSI — Manual or Drone' },
  { id: 'utosi_ndtReporter',      label: 'UT-OSI — NDT Reporter' },

  // UT-ISI — Ultrasonic Testing In-Service Inspection
  { id: 'utisi_inspectionStatus', label: 'UT-ISI — Inspection Status' },
  { id: 'utisi_terraProcedure',   label: 'UT-ISI — Terra Procedure' },
  { id: 'utisi_typeOfInspection', label: 'UT-ISI — Type of Inspection' },
  { id: 'utisi_surfaceCondition', label: 'UT-ISI — Surface Condition' },
  { id: 'utisi_insideOutside',    label: 'UT-ISI — Inside / Outside' },
  { id: 'utisi_manualOrDrone',    label: 'UT-ISI — Manual or Drone' },
  { id: 'utisi_ndtReporter',      label: 'UT-ISI — NDT Reporter' },

  // UT — Ultrasonic Inspection (umbrella; uses the 'ut' typePrefix in
  // INSPECTION_TYPE_CONFIG, mirrors UT-OSI/UT-ISI field set).
  { id: 'ut_inspectionStatus', label: 'UT — Inspection Status' },
  { id: 'ut_terraProcedure',   label: 'UT — Terra Procedure' },
  { id: 'ut_typeOfInspection', label: 'UT — Type of Inspection' },
  { id: 'ut_surfaceCondition', label: 'UT — Surface Condition' },
  { id: 'ut_insideOutside',    label: 'UT — Inside / Outside' },
  { id: 'ut_manualOrDrone',    label: 'UT — Manual or Drone' },
  { id: 'ut_ndtReporter',      label: 'UT — NDT Reporter' },
  // UT — Measurements (Create Table modal). Mirrors UT-OSI / UT-ISI.
  { id: 'ut_measurementComponent', label: 'UT — Measurement Component' },
  { id: 'ut_measurementType',      label: 'UT — Measurement Type' },

  // DEFO — Deformation Measurement Analysis
  { id: 'defo_inspectionStatus',   label: 'DEFO — Inspection Status' },
  { id: 'defo_terraProcedure',     label: 'DEFO — Terra Procedure' },
  { id: 'defo_acceptanceStandard', label: 'DEFO — Acceptance Standard' },
  { id: 'defo_typeOfInspection',   label: 'DEFO — Type of Inspection' },
  { id: 'defo_surfaceCondition',   label: 'DEFO — Surface Condition' },
  { id: 'defo_insideOutside',      label: 'DEFO — Inside / Outside' },
  { id: 'defo_manualOrDrone',      label: 'DEFO — Manual or Drone' },
  { id: 'defo_ndtReporter',        label: 'DEFO — NDT Reporter' },

  // MT-OSI — Magnetic Testing Out-of-Service Inspection
  { id: 'mtosi_inspectionStatus',    label: 'MT-OSI — Inspection Status' },
  { id: 'mtosi_terraProcedure',      label: 'MT-OSI — Terra Procedure' },
  { id: 'mtosi_typeOfInspection',    label: 'MT-OSI — Type of Inspection' },
  { id: 'mtosi_surfaceCondition',    label: 'MT-OSI — Surface Condition' },
  { id: 'mtosi_insideOutside',       label: 'MT-OSI — Inside / Outside' },
  { id: 'mtosi_manualOrDrone',       label: 'MT-OSI — Manual or Drone' },
  { id: 'mtosi_ndtReporter',         label: 'MT-OSI — NDT Reporter' },
  { id: 'mtosi_typeOfMagnetization', label: 'MT-OSI — Type of Magnetization' },
  { id: 'mtosi_typeOfWelding',       label: 'MT-OSI — Type of Welding' },
  { id: 'mtosi_methodOfWelding',     label: 'MT-OSI — Method of Welding' },

  // MT-ISI — Magnetic Testing In-Service Inspection
  { id: 'mtisi_inspectionStatus',    label: 'MT-ISI — Inspection Status' },
  { id: 'mtisi_terraProcedure',      label: 'MT-ISI — Terra Procedure' },
  { id: 'mtisi_typeOfInspection',    label: 'MT-ISI — Type of Inspection' },
  { id: 'mtisi_surfaceCondition',    label: 'MT-ISI — Surface Condition' },
  { id: 'mtisi_insideOutside',       label: 'MT-ISI — Inside / Outside' },
  { id: 'mtisi_manualOrDrone',       label: 'MT-ISI — Manual or Drone' },
  { id: 'mtisi_ndtReporter',         label: 'MT-ISI — NDT Reporter' },
  { id: 'mtisi_typeOfMagnetization', label: 'MT-ISI — Type of Magnetization' },
  { id: 'mtisi_typeOfWelding',       label: 'MT-ISI — Type of Welding' },
  { id: 'mtisi_methodOfWelding',     label: 'MT-ISI — Method of Welding' },

  // MT — Magnetic Inspection (umbrella; 'mt' typePrefix in
  // INSPECTION_TYPE_CONFIG, mirrors MT-OSI / MT-ISI field set).
  { id: 'mt_inspectionStatus',    label: 'MT — Inspection Status' },
  { id: 'mt_terraProcedure',      label: 'MT — Terra Procedure' },
  { id: 'mt_typeOfInspection',    label: 'MT — Type of Inspection' },
  { id: 'mt_surfaceCondition',    label: 'MT — Surface Condition' },
  { id: 'mt_insideOutside',       label: 'MT — Inside / Outside' },
  { id: 'mt_manualOrDrone',       label: 'MT — Manual or Drone' },
  { id: 'mt_ndtReporter',         label: 'MT — NDT Reporter' },
  { id: 'mt_typeOfMagnetization', label: 'MT — Type of Magnetization' },
  { id: 'mt_typeOfWelding',       label: 'MT — Type of Welding' },
  { id: 'mt_methodOfWelding',     label: 'MT — Method of Welding' },

  // PT-OSI — Penetrant Testing Out-of-Service Inspection. Per
  // user spec: no Type of Magnetization. Adds Application Method +
  // Processing Time in the same two slots on the Examination page.
  { id: 'ptosi_inspectionStatus',    label: 'PT-OSI — Inspection Status' },
  { id: 'ptosi_terraProcedure',      label: 'PT-OSI — Terra Procedure' },
  { id: 'ptosi_typeOfInspection',    label: 'PT-OSI — Type of Inspection' },
  { id: 'ptosi_surfaceCondition',    label: 'PT-OSI — Surface Condition' },
  { id: 'ptosi_insideOutside',       label: 'PT-OSI — Inside / Outside' },
  { id: 'ptosi_manualOrDrone',       label: 'PT-OSI — Manual or Drone' },
  { id: 'ptosi_ndtReporter',         label: 'PT-OSI — NDT Reporter' },
  { id: 'ptosi_applicationMethod',   label: 'PT-OSI — Penetrant Application Method' },
  { id: 'ptosi_processingTime',      label: 'PT-OSI — Processing Time (mins)' },
  { id: 'ptosi_typeOfWelding',       label: 'PT-OSI — Type of Welding' },
  { id: 'ptosi_methodOfWelding',     label: 'PT-OSI — Method of Welding' },

  // PT-ISI — Penetrant Testing In-Service Inspection
  { id: 'ptisi_inspectionStatus',    label: 'PT-ISI — Inspection Status' },
  { id: 'ptisi_terraProcedure',      label: 'PT-ISI — Terra Procedure' },
  { id: 'ptisi_typeOfInspection',    label: 'PT-ISI — Type of Inspection' },
  { id: 'ptisi_surfaceCondition',    label: 'PT-ISI — Surface Condition' },
  { id: 'ptisi_insideOutside',       label: 'PT-ISI — Inside / Outside' },
  { id: 'ptisi_manualOrDrone',       label: 'PT-ISI — Manual or Drone' },
  { id: 'ptisi_ndtReporter',         label: 'PT-ISI — NDT Reporter' },
  { id: 'ptisi_applicationMethod',   label: 'PT-ISI — Penetrant Application Method' },
  { id: 'ptisi_processingTime',      label: 'PT-ISI — Processing Time (mins)' },
  { id: 'ptisi_typeOfWelding',       label: 'PT-ISI — Type of Welding' },
  { id: 'ptisi_methodOfWelding',     label: 'PT-ISI — Method of Welding' },

  // PT — Penetrant Inspection (umbrella)
  { id: 'pt_inspectionStatus',    label: 'PT — Inspection Status' },
  { id: 'pt_terraProcedure',      label: 'PT — Terra Procedure' },
  { id: 'pt_typeOfInspection',    label: 'PT — Type of Inspection' },
  { id: 'pt_surfaceCondition',    label: 'PT — Surface Condition' },
  { id: 'pt_insideOutside',       label: 'PT — Inside / Outside' },
  { id: 'pt_manualOrDrone',       label: 'PT — Manual or Drone' },
  { id: 'pt_ndtReporter',         label: 'PT — NDT Reporter' },
  { id: 'pt_applicationMethod',   label: 'PT — Penetrant Application Method' },
  { id: 'pt_processingTime',      label: 'PT — Processing Time (mins)' },
  { id: 'pt_typeOfWelding',       label: 'PT — Type of Welding' },
  { id: 'pt_methodOfWelding',     label: 'PT — Method of Welding' },

  // CW-OSI — Corner-weld Internal Dimension Inspection
  // Acceptance Standard is a locked default ("Not applicable") for CW-OSI,
  // so there's no dropdown to register.
  { id: 'cwosi_inspectionStatus',   label: 'CW-OSI — Inspection Status' },
  { id: 'cwosi_terraProcedure',     label: 'CW-OSI — Terra Procedure' },
  { id: 'cwosi_typeOfInspection',   label: 'CW-OSI — Type of Inspection' },
  { id: 'cwosi_surfaceCondition',   label: 'CW-OSI — Surface Condition' },
  { id: 'cwosi_insideOutside',      label: 'CW-OSI — Inside / Outside' },
  { id: 'cwosi_manualOrDrone',      label: 'CW-OSI — Manual or Drone' },
  { id: 'cwosi_ndtReporter',        label: 'CW-OSI — NDT Reporter' },

  // Visual Inspection Captures (VT-OSI / VT-ISI)
  { id: 'captures_inspectObjectType',  label: 'Captures — 3D-Inspect Object Type' },
  { id: 'captures_inspectComposition', label: 'Captures — 3D-Inspect Composition Breakdown' },

  // UT-OSI — Ultrasonic Measurements (Create Table modal)
  // Hierarchy: Component (primary) → Measurement (secondary) → Heading (tertiary)
  { id: 'utosi_measurementComponent', label: 'UT-OSI — Measurement Component' },
  { id: 'utosi_measurementType',      label: 'UT-OSI — Measurement Type' },

  // UT-ISI — Ultrasonic Measurements (Create Table modal)
  { id: 'utisi_measurementComponent', label: 'UT-ISI — Measurement Component' },
  { id: 'utisi_measurementType',      label: 'UT-ISI — Measurement Type' },

  // Equipment metadata (shared across all equipment types)
  { id: 'equipment_typeOfOperation', label: 'Equipment — Type of Operation' },
];

export default APP_DROPDOWNS;
